import React, { useState } from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import AccountList from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/AccountList';
import Paper from '@mui/material/Paper';
import DetailsSubTab from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/AccountManagementTab/components/DetailsSubTab';
import UsersList from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/UsersList';
import ApprovalFlow from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/ApprovalFlow';
import GeneralInfo from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/GeneralInfo';

interface AccountManagementTabProps {
  providerId: string;
}

const AccountManagementTab: React.FC<AccountManagementTabProps> = ({ providerId }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newIndex: number) => setTabIndex(newIndex);

  return (
    <Stack direction="row" spacing={3} height="100%" p={3}>
      <DetailsSubTab handleClick={setTabIndex} selected={tabIndex} handleTabChange={handleTabChange} />

      <Box sx={{ flexGrow: 2 }}>
        <Stack component={Paper} height="100%">
          {tabIndex === 0 && <GeneralInfo providerId={providerId} />}
          {tabIndex === 1 && <AccountList providerId={providerId} />}
          {tabIndex === 2 && <ApprovalFlow providerId={providerId} />}
          {tabIndex === 3 && <UsersList providerId={providerId} />}
        </Stack>
      </Box>
    </Stack>
  );
};

export default AccountManagementTab;
